import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel, PanelHeaderTemplateOptions } from "primereact/panel";
import NadaConsta from "../../../../components/nadaConsta";
import { useTranslation } from "react-i18next";

export const Gps894Page = (data: any) => {
  const PENDENCIAS_F = data?.PEND_FINANCEIRAS;
 
  const { t } = useTranslation();
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {PENDENCIAS_F?.OCORRENCIAS && PENDENCIAS_F?.OCORRENCIAS.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('restricaoFinanceira')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('restricaoFinanceira')}</span>) }</div>;
  }

  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {data.PROTESTOS.OCORRENCIAS  && data.PROTESTOS.OCORRENCIAS.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestosNacional2')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestosNacional2')}</span>) }</div>;
  }

  const getValue = (value: string) => value || "Não informado";


  return (
    <div>

      <Panel headerTemplate={headerTemplate}  toggleable>
        {!PENDENCIAS_F || !PENDENCIAS_F.OCORRENCIAS || PENDENCIAS_F?.OCORRENCIAS.length === 0 ? (<NadaConsta></NadaConsta>) :(
        <DataTable
          value={PENDENCIAS_F?.OCORRENCIAS}
        >
          <Column header="Modalidade" field="MODALIDADE" />
          <Column header="Contrato" field="CONTRATO" />
          <Column header="Tipo de Devedor" field="TIPO_DEVEDOR" />
          <Column header="Credor" field="CREDOR" />
          <Column header="Valor" field="VALOR" />
          <Column header="Data de Vencimento" field="DATA_VENCIMENTO" />
          <Column header="Data de Inclusão" field="DATA_INCLUSAO" />
          <Column header="Origem" field="ORIGEM" />
        </DataTable>)}
      </Panel>
      <br />
      <br />
      <Panel headerTemplate={headerTemplateProtesto} toggleable>
        {!data.PROTESTOS.OCORRENCIAS || data?.PROTESTOS?.OCORRENCIAS.length === 0 ? (<NadaConsta></NadaConsta>) : (
        <DataTable
          value={data?.PROTESTOS?.OCORRENCIAS}
          emptyMessage="Nada consta"
        >
          <Column
            header="Credor"
            body={(data: any) => getValue(data?.CREDOR)}
          />
          <Column
            header="Origem"
            body={(data: any) => getValue(data?.ORIGEM)}
          />
          <Column
            header="Quantidade"
            body={(data: any) => getValue(data?.QUANTIDADE)}
          />
          <Column header="Data" body={(data: any) => getValue(data?.DATA)} />
          <Column
            header="Vencimento"
            body={(data: any) => getValue(data?.VENCIMENTO)}
          />
        </DataTable>)}
      </Panel>
      <br />
      <br />
      
    </div>
  );
};
